import { useEffect } from 'react';
import { log } from 'log';
import { prop, pick } from 'ramda';
import { useUserSelector, useAuthSelector, useSportsbookSelector, useSocketSelector } from 'js/store/hooks';

export const useSportsbookSyncSession = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const {
        isAppInitialized,
        isRenderingStarted
    } = useSportsbookSelector(pick(['isAppInitialized', 'isRenderingStarted']));
    const {
        isLogoutInProcess,
        isLoginInProcess,
        wasAutoLoginCompleted
    } = useAuthSelector(pick(['isLogoutInProcess', 'isLoginInProcess', 'wasAutoLoginCompleted']));
    const connected = useSocketSelector(prop('connected'));

    useEffect(() => {
        if (isLogoutInProcess || isLoginInProcess || !wasAutoLoginCompleted) {
            return;
        }

        if (!connected || !isAppInitialized || !isRenderingStarted) {
            return;
        }

        try {
            window.Sportsbook.sendMessage('SYNC_SESSION');
        } catch (error) {
            log('log', '[SPORTSBOOK | Portal] sync session error', error);
        }
    }, [
        isLoggedIn,
        isLogoutInProcess,
        isLoginInProcess,
        isRenderingStarted,
        wasAutoLoginCompleted,
        isAppInitialized,
        connected
    ]);
};
